@if (mode === "mixed") {
  <nz-spin [nzTip]="'Loading...'" [nzSpinning]="loading">
    <ng-container [formGroup]="form">
      <!-- @if (isSupportRule("min_stay_on_arrival")) {
        <div class="v4-layout-field">
          <div class="v4-layout-field-label w-[200px]">
            {{ "operate_sidebar-rules_settings_html_min_stay_on_arrival" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <input
                type="number"
                nz-input
                nzSize="large"
                [placeholder]="'operate_sidebar-rules_settings_html_min_stay_on_arrival' | translate"
                formControlName="min_stay_on_arrival" />
              <i
                class="ml-2"
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                nz-tooltip
                nzTooltipOverlayClassName="w-[400px]"
                [nzTooltipTitle]="'operate_sidebar-rules_settings_html_min_stay_on_arrival_tip' | translate"></i>
            </div>
          </div>
        </div>
      } -->

      <!-- @if (isSupportRule("max_stay_on_arrival")) {
        <div class="v4-layout-field">
          <div class="v4-layout-field-label w-[200px]">
            {{ "operate_sidebar-rules_settings_html_max_stay_on_arrival" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <input
                type="number"
                nz-input
                nzSize="large"
                [placeholder]="'operate_sidebar-rules_settings_html_max_stay_on_arrival' | translate"
                formControlName="max_stay_on_arrival" />
              <i
                class="ml-2"
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                nz-tooltip
                nzTooltipOverlayClassName="w-[400px]"
                [nzTooltipTitle]="'operate_sidebar-rules_settings_html_max_stay_on_arrival_tip' | translate"></i>
            </div>
          </div>
        </div>
      }

      @if (isSupportRule("min_stay_through")) {
        <div class="v4-layout-field">
          <div class="v4-layout-field-label w-[200px]">
            {{ "operate_sidebar-rules_settings_html_min_stay_through" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <input
                type="number"
                nz-input
                nzSize="large"
                [placeholder]="'operate_sidebar-rules_settings_html_min_stay_through' | translate"
                formControlName="min_stay_through" />
              <i
                class="ml-2"
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                nz-tooltip
                nzTooltipOverlayClassName="w-[400px]"
                [nzTooltipTitle]="'operate_sidebar-rules_settings_html_min_stay_through_tip' | translate"></i>
            </div>
          </div>
        </div>
      }

      @if (isSupportRule("max_stay_through")) {
        <div class="v4-layout-field">
          <div class="v4-layout-field-label w-[200px]">
            {{ "operate_sidebar-rules_settings_html_max_stay_through" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <input
                type="number"
                nz-input
                nzSize="large"
                [placeholder]="'operate_sidebar-rules_settings_html_max_stay_through' | translate"
                formControlName="max_stay_through" />
              <i
                class="ml-2"
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                nz-tooltip
                nzTooltipOverlayClassName="w-[400px]"
                [nzTooltipTitle]="'operate_sidebar-rules_settings_html_max_stay_through_tip' | translate"></i>
            </div>
          </div>
        </div>
      }

      @if (isSupportRule("exact_stay_on_arrival")) {
        <div class="v4-layout-field">
          <div class="v4-layout-field-label w-[200px]">
            {{ "operate_sidebar-rules_settings_html_extra_stay_on_arrival" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <input
                type="number"
                nz-input
                nzSize="large"
                [placeholder]="'operate_sidebar-rules_settings_html_extra_stay_on_arrival' | translate"
                formControlName="exact_stay_on_arrival" />
              <i
                class="ml-2"
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                nz-tooltip
                nzTooltipOverlayClassName="w-[400px]"
                [nzTooltipTitle]="'operate_sidebar-rules_settings_html_extra_stay_on_arrival_tip' | translate"></i>
            </div>
          </div>
        </div>
      }

      @if (isSupportRule("min_advance_reservation")) {
        <div class="v4-layout-field" formGroupName="min_advance_reservation">
          <div class="v4-layout-field-label w-[200px]">
            {{ "operate_sidebar-rules_settings_html_min_advance_reservation" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <input
                type="number"
                nz-input
                nzSize="large"
                [placeholder]="'operate_sidebar-rules_settings_html_days' | translate"
                formControlName="days"
                class="flex-1" />

              <div class="flex-1 ml-2">
                <host-select
                  size="large"
                  [placeholder]="'operate_sidebar-rules_settings_html_hours' | translate"
                  formControlName="hours"
                  [listOfOption]="optionsOfMARHours"
                  [defaultValue]="null"></host-select>
              </div>

              <i
                class="ml-2"
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                nz-tooltip
                nzTooltipOverlayClassName="w-[400px]"
                [nzTooltipTitle]="'operate_sidebar-rules_settings_html_min_advance_reservation_tip' | translate"></i>
            </div>
          </div>
        </div>
      }

      @if (isSupportRule("max_advance_reservation")) {
        <div class="v4-layout-field" formGroupName="max_advance_reservation">
          <div class="v4-layout-field-label w-[200px]">
            {{ "operate_sidebar-rules_settings_html_max_advance_reservation" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <input
                type="number"
                nz-input
                nzSize="large"
                [placeholder]="'operate_sidebar-rules_settings_html_max_advance_reservation' | translate"
                formControlName="days" />
              <i
                class="ml-2"
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                nz-tooltip
                nzTooltipOverlayClassName="w-[400px]"
                [nzTooltipTitle]="'operate_sidebar-rules_settings_html_max_advance_reservation_tip' | translate"></i>
            </div>
          </div>
        </div>
      }

      @if (isSupportRule("closed_on_arrival")) {
        <div class="v4-layout-field">
          <div class="v4-layout-field-label w-[200px]">
            {{ "operate_sidebar-rules_settings_html_closed_on_arrival" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <label nz-checkbox formControlName="closed_on_arrival">
                {{ "property-property_detail-booking_setting_html_启用" | translate }}
              </label>
              <i
                class="ml-2"
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                nz-tooltip
                nzTooltipOverlayClassName="w-[400px]"
                [nzTooltipTitle]="'operate_sidebar-rules_settings_html_closed_on_arrival_tip' | translate"></i>
            </div>
          </div>
        </div>
      }

      @if (isSupportRule("closed_on_departure")) {
        <div class="v4-layout-field">
          <div class="v4-layout-field-label w-[200px]">
            {{ "operate_sidebar-rules_settings_html_closed_on_departure" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <label nz-checkbox formControlName="closed_on_departure">
                {{ "property-property_detail-booking_setting_html_启用" | translate }}
              </label>
              <i
                class="ml-2"
                nz-icon
                nzType="exclamation-circle"
                nzTheme="outline"
                nz-tooltip
                nzTooltipOverlayClassName="w-[400px]"
                [nzTooltipTitle]="'operate_sidebar-rules_settings_html_closed_on_departure_tip' | translate"></i>
            </div>
          </div>
        </div>
      }

      @if (isSupportRule("rule_id")) {
        <div class="v4-layout-field">
          <div class="v4-layout-field-label w-[200px]">
            {{ "operate_sidebar-rules_settings_html_seasonal_rule_sets" | translate }}
          </div>
          <div class="v4-layout-field-control">
            <div class="v4-layout-field-row">
              <host-select
                size="large"
                [showArrow]="true"
                [placeholder]="'operate_sidebar-rules_settings_html_seasonal_rule_sets' | translate"
                [listOfOption]="airbnbRulesList"
                [defaultValue]="null"
                formControlName="rule_id"></host-select>
            </div>
          </div>
        </div>

        <div class="v4-layout-field">
          <div class="v4-layout-field-control">
            <nz-alert
              nzShowIcon
              [nzMessage]="'operate_sidebar-rules_settings_html_seasonal_rule_sets_tip' | translate"></nz-alert>
          </div>
        </div>
      } -->

      @for (control of mixedControlCfg; track $index) {
        @if (isSupportRule(control.name)) {
          @if (control.isGroup) {
            <div class="v4-layout-field" [formGroupName]="control.name">
              <div class="v4-layout-field-label w-[200px]">
                {{ control.label }}
              </div>
              <div class="v4-layout-field-control">
                <div class="v4-layout-field-row">
                  @for (child of control.children; track $index) {
                    <div class="flex-1" [class.ml-2]="$index !== 0">
                      @switch (child.type) {
                        @case ("input") {
                          <input
                            type="number"
                            nz-input
                            nzSize="large"
                            [placeholder]="child.placeholder"
                            [formControlName]="child.name"
                            class="flex-1" />
                        }
                        @case ("select") {
                          <host-select
                            size="large"
                            [placeholder]="child.placeholder"
                            [formControlName]="child.name"
                            [listOfOption]="child.options()"
                            [defaultValue]="null"></host-select>
                        }
                      }
                    </div>
                  }

                  @if (control.tooltip) {
                    <i
                      class="ml-2"
                      nz-icon
                      nzType="exclamation-circle"
                      nzTheme="outline"
                      nz-tooltip
                      nzTooltipOverlayClassName="w-[400px]"
                      [nzTooltipTitle]="control.tooltip"></i>
                  }
                </div>
              </div>
            </div>
          } @else {
            <div class="v4-layout-field">
              <div class="v4-layout-field-label w-[200px]">
                {{ control.label }}
              </div>
              <div class="v4-layout-field-control">
                <div class="v4-layout-field-row">
                  @switch (control.type) {
                    @case ("input") {
                      <input
                        type="number"
                        nz-input
                        nzSize="large"
                        [placeholder]="control.placeholder"
                        [formControlName]="control.name" />
                    }

                    @case ("select") {
                      <host-select
                        size="large"
                        [showArrow]="true"
                        [placeholder]="control.placeholder"
                        [listOfOption]="control.options()"
                        [defaultValue]="null"
                        [formControlName]="control.name"></host-select>
                    }

                    @case ("checkbox") {
                      <label nz-checkbox [formControlName]="control.name">
                        <!-- Enabled -->
                        {{ "property-property_detail-booking_setting_html_启用" | translate }}
                      </label>
                    }
                  }

                  @if (control.tooltip) {
                    <i
                      class="ml-2"
                      nz-icon
                      nzType="exclamation-circle"
                      nzTheme="outline"
                      nz-tooltip
                      nzTooltipOverlayClassName="w-[400px]"
                      [nzTooltipTitle]="control.tooltip"></i>
                  }
                </div>
              </div>
            </div>

            @if (control.extra) {
              <div class="v4-layout-field">
                <div class="v4-layout-field-control">
                  <nz-alert nzShowIcon [nzMessage]="control.extra"></nz-alert>
                </div>
              </div>
            }
          }
        }
      }
    </ng-container>
  </nz-spin>
} @else {
  <div class="v4-layout-field" [formGroup]="form">
    <div class="v4-layout-field-label flex-1 flex flex-row items-center cursor-pointer">
      <img [src]="(house().thirdparty_type | thirdparty)?.icon_color" alt="" class="w-[18px] h-[18px] rounded-full" />
      <span
        class="ml-1 mr-[2px] max-w-[260px] ellipsis-line-2 leading-tight text-[#000000d9]"
        [ngClass]="{
          '!text-[#48CA93]': activated
        }">
        {{ house().thirdparty_house_title }}
      </span>
      <!-- <div class="flex flex-row items-center cursor-pointer">
      </div> -->
    </div>
    <div class="v4-layout-field-control !flex-none">
      <div class="v4-layout-field-row justify-end">
        @switch (mode) {
          @case ("rule_id") {
            <div class="w-[100px]">
              <host-select
                size="large"
                [showArrow]="true"
                [placeholder]="
                  ruleId.disabled ? 'N/A' : ('operate_sidebar-rules_settings_html_seasonal_rule_sets' | translate)
                "
                [listOfOption]="airbnbRulesList"
                [defaultValue]="null"
                formControlName="rule_id"></host-select>
            </div>
          }

          @case ("min_advance_reservation") {
            <div class="flex flex-row" formGroupName="min_advance_reservation">
              <input
                type="number"
                nz-input
                nzSize="large"
                [placeholder]="minARDays.disabled ? 'N/A' : ('operate_sidebar-rules_settings_html_days' | translate)"
                formControlName="days"
                class="w-[80px]" />

              <div class="w-[80px] ml-2">
                <host-select
                  size="large"
                  [placeholder]="
                    minARHours.disabled ? 'M/A' : ('operate_sidebar-rules_settings_html_hours' | translate)
                  "
                  formControlName="hours"
                  [listOfOption]="optionsOfMARHours"
                  [defaultValue]="null"></host-select>
              </div>
            </div>
          }

          @case ("max_advance_reservation") {
            <div class="flex flex-row" formGroupName="max_advance_reservation">
              <input
                type="number"
                nz-input
                nzSize="large"
                [placeholder]="maxARDays.disabled ? 'N/A' : ('operate_sidebar-rules_settings_html_days' | translate)"
                formControlName="days"
                class="w-[80px]" />
            </div>
          }

          @case ("closed_on_arrival") {
            <label nz-checkbox formControlName="closed_on_arrival">
              <!-- Enabled -->
              {{ "property-property_detail-booking_setting_html_启用" | translate }}
            </label>
          }

          @case ("closed_on_departure") {
            <label nz-checkbox formControlName="closed_on_departure">
              <!-- Enabled -->
              {{ "property-property_detail-booking_setting_html_启用" | translate }}
            </label>
          }

          @case ("min_stay_through") {
            <input
              class="w-[80px]"
              type="number"
              nz-input
              nzSize="large"
              formControlName="min_stay_through"
              [placeholder]="minStayThrough.disabled ? 'N/A' : ''" />
          }
          @case ("max_stay_through") {
            <input
              class="w-[80px]"
              type="number"
              nz-input
              nzSize="large"
              formControlName="max_stay_through"
              [placeholder]="maxStayThrough.disabled ? 'N/A' : ''" />
          }
          @case ("min_stay_on_arrival") {
            <input
              class="w-[80px]"
              type="number"
              nz-input
              nzSize="large"
              formControlName="min_stay_on_arrival"
              [placeholder]="minStayOnArrival.disabled ? 'N/A' : ''" />
          }
          @case ("max_stay_on_arrival") {
            <input
              class="w-[80px]"
              type="number"
              nz-input
              nzSize="large"
              formControlName="max_stay_on_arrival"
              [placeholder]="maxStayOnArrival.disabled ? 'N/A' : ''" />
          }
          @case ("exact_stay_on_arrival") {
            <input
              class="w-[80px]"
              type="number"
              nz-input
              nzSize="large"
              formControlName="exact_stay_on_arrival"
              [placeholder]="exactStayOnArrival.disabled ? 'N/A' : ''" />
          }
        }
      </div>
    </div>
  </div>
}
